import { combineReducers } from "redux";

import userReducer from "./userReducer";
import presentationReducer from "./presentationReducer";
import templateReducer from "./templateReducer";
import importReducer from "./importReducer";
import emailerReducer from "./emailerReducer";
import componentReducer from "./componentsReducer.js";
import importJSONReducer from "./importJSONReducer.js";
import menu from "./menu";
import nextPresentationReducer from "./nextPresentationReducer.js";
import migrationContentReducer from "./migrationContentReducer.js";

export default combineReducers({
  userStore: userReducer,
  presentationStore: presentationReducer,
  nextPresentationStore: nextPresentationReducer,
  templateStore: templateReducer,
  importStore: importReducer,
  emailerStore: emailerReducer,
  componentStore: componentReducer,
  importJSONStore: importJSONReducer,
  migrationContentStore: migrationContentReducer,
  menu: menu,
});
